import React, {useEffect} from "react";

const LoadingSpinner = ({target = null}) => {
    useEffect(() => {
        if (target && document.getElementsByClassName(target).length !== 0) {
            document.getElementsByClassName(target)[0].style.pointerEvents = 'none';
            document.getElementsByClassName(target)[0].style.opacity = 0.5;
        }

        return () => {
            if (target && document.getElementsByClassName(target).length !== 0) {
                document.getElementsByClassName(target)[0].style.pointerEvents = '';
                document.getElementsByClassName(target)[0].style.opacity = 1;
            }
        }
    });

    return (
        <div className='position-absolute top-50 start-50' onClick={(ev) => {ev.stopPropagation()}}>
            <div className='px-4 py-3 bg-white rounded border shadow-sm'>
                <div className="spinner-border text-secondary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    )
}

export default LoadingSpinner;
